export default __webpack_public_path__ + "static/media/iconlogo.7807b9b3.png";